<template>
	<v-card>
		<v-card-title>
			<v-row
				no-gutters
				class="d-flex justify-space-between"
			>
				<v-col>
					<v-icon
						start
						icon="$hammer"
					/>
					<translate>
						Suppliers
					</translate>
				</v-col>
				<v-spacer
					class="flex-grow-1 flex-shrink-0"
				/>
				<v-col
					class="flex-shrink-1 flex-grow-0"
				>
					<suppliers-dialog>
						<template #activator="props">
							<v-btn
								prepend-icon="$plus"
								color="primary"
								v-bind="props"
							>
								<translate>
									New Supplier
								</translate>
							</v-btn>
						</template>
					</suppliers-dialog>
				</v-col>
			</v-row>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-text-field
						v-model:model-value="search"
						class="flex-shrink-1 flex-grow-0"
						variant="outlined"
						:label="$gettext('Search')"
						hide-details
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<v-row>
				<v-col>
					<model-table
						ref="modelTable"
						v-model:page="page"
						v-model:items-per-page="itemsPerPage"
						endpoint="/api/v0/suppliers"
						:headers="headers"
						:filter="(item) => { return item.serviceCenter.toLowerCase().includes(search.toLowerCase()) }"
						@items-filtered="filtered => rows = filtered.sort(sortDesc)"
					>
						<template #item.countryId="{ item }">
							<country-flag :country-code="item.country.countryCode" />
						</template>
						<template #item.taxtypeId="{ item }">
							{{ item.taxtype.name }}
						</template>
						<template
							#item.actions="{ index }"
						>
							<suppliers-dialog
								v-model:supplier="rows[((page - 1) * itemsPerPage) + index]"
								@update:supplier="$refs.modelTable.index()"
							>
								<template #activator="props">
									<v-btn
										v-bind="props"
										variant="text"
										icon="$squareEdit"
									/>
								</template>
							</suppliers-dialog>
						</template>
					</model-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import SuppliersDialog from '../../../molecules/SuppliersDialog.vue';
import CountryFlag from '../../../atoms/CountryFlag.vue';

export default {
	components: {
		CountryFlag,
		SuppliersDialog
	},
	data () {
		return {
			search: '',
			rows: [],
			page: 1,
			sortBy: [{
				key: 'id', 'order': 'desc'
			},],
			itemsPerPage: 10,
			headers: [
				{
					title: this.$gettext('ID'), value: 'id', sortable: false
				},
				{
					title: this.$gettext('Service Center'), value: 'serviceCenter', sortable: false
				},
				{
					title: this.$gettext('Country'), value: 'countryId', sortable: false
				},
				{
					title: this.$gettext('Tax Type'), value: 'taxtypeId', sortable: false
				},
				{
					title: this.$gettext('Actions'), value: 'actions', sortable: false
				},
			]
		};
	},

	methods: {
		/**
		 * Sort by supplier ids descending
		 *
		 * @param {object} supplierA
		 * @param {object} supplierB
		 * @returns {number}
		 */
		sortDesc (supplierA, supplierB) {
			return supplierB.id - supplierA.id;
		}
	}
};
</script>
